import { render, staticRenderFns } from "./LabelSet.vue?vue&type=template&id=35de3c50&scoped=true"
import script from "./LabelSet.vue?vue&type=script&lang=js"
export * from "./LabelSet.vue?vue&type=script&lang=js"
import style0 from "./LabelSet.vue?vue&type=style&index=0&id=35de3c50&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35de3c50",
  null
  
)

export default component.exports